import PDPAService from "@/core/PDPA/service/BzbsPDPA.js";
import { PDPAModel } from '@/core/PDPA/model/PDPAModel.js';
//mixin
import ModalMixin from "@/mixin/ModalMixin.js";
import AccountMixin from "@/mixin/AccountMixin.js"
import LocaleMixin from "@/mixin/LocaleMixin.js";
//helper
import CacheHelper from "@/helper/CacheHelper.js";
import Util from "@/helper/Utility.js";
export default {
    mixins: [ModalMixin, AccountMixin, LocaleMixin],
    data: function () {
        return {
            termsVersion: null,
            privacyVersion: null,
            ageVersion: null,
            marketingVersion: null,
            consentPrivacy: null,
            consentTerms: null,
            consentAge: null,
            consentMarketing: null,
            marketing: {
                email: null,
                sms: null,
                line: null,
                noti: null
            },
            page: null
        };
    },
    created: function () {
        this.initialOtherModal();
        // this.getPDPAConsent();
    },
    methods: {
        getPDPAConsent: function (targetPage) {
            var token = this.getToken();
            this.page = targetPage;
            return new Promise((resolve,reject) => {
                PDPAService.apiGetNewConsent(token).subscribe((data) => {
                    this.consentPrivacy = data.DataPrivacy;
                    this.consentTerms = data.TermAndCondition;
                    this.consentAge = data.ConsentAge;
                    this.consentmarketing = data.MarketingOption;
                    this.marketing = {
                        email: data.EmailMarketing,
                        sms: data.SMSMarketing,
                        line: data.LineMarketing,
                        noti: data.NotificationMarketing
                    }
                    this.checkPdpa();
                    resolve(data);
                }, (err) => {
                    console.log(err);
                    reject(err);
                });
            });
        },
        checkPdpa: function () {
            return new Promise((resolve,reject) => {
                PDPAService.apiGetPDPAVersion().subscribe((data) => {
                    this.termsVersion = data.terms.current_version;
                    this.privacyVersion = data.privacy;
                    this.marketingVersion = data.marketing;
                    this.ageVersion = data.age;

                   if (this.consentTerms != this.termsVersion
                        || this.consentPrivacy != this.privacyVersion
                        || this.marketingVersion != this.consentmarketing
                        || this.consentAge != this.ageVersion) {
                        this.termsReConsentModal.clearText()
                                                .setType("terms")
                                                .setTitle(this.lbl.static.terms.title_topbar)
                                                .setTag('accept-terms')
                                                .show();
                        this.termsReConsentModal.onClickOk((data) =>{
                            if (data.tag == 'accept-terms') {
                                this.privacyReConsentModal.clearText()
                                                        .setType("privacy")
                                                        .setTitle(this.lbl.static.privacy.title_topbar)
                                                        .setTag('accept-privacy')
                                                        .show();
                            }
                        });
                        this.privacyReConsentModal.onClickOk((data) =>{
                            if (data.tag == 'accept-privacy') {
                                this.marketingReConsentModal.clearText()
                                                            .setTag('accept-marketing')
                                                            .show();
                            }
                        });
                        this.marketingReConsentModal.onClickOk((data) =>{
                            if (data.tag == 'accept-marketing') {
                                this.marketing.email = data.consent.email;
                                this.marketing.sms = data.consent.sms;
                                this.marketing.line = data.consent.line;
                                this.ageConsentAlertModal.clearText().show();
                            }
                        });
                        this.ageConsentAlertModal.onClickOk((data) => {
                            if (data) {
                                this.submitConsent();
                            }
                        });
                    } else {
                        this.redirectLogin();
                    }
                    resolve(data);
                }, (err) => {
                    this.errorApi(err);
                    reject(err);
                })
            });
        },
        submitConsent: function(){
            //Save Consent
            var token = this.getToken();
            let consentModel = new PDPAModel();
            var consent = {
                termandcondition: this.termsVersion,
                dataprivacy: this.privacyVersion,
                consentAge: 20,
                email: this.marketing.email,
                sms: this.marketing.sms,
                notification: this.marketing.noti,
                line: this.marketing.line,
                marketingOption: this.marketingVersion
            }
            consentModel.setPDPAModel(consent);
            let params = consentModel.getParams();
            PDPAService.apiPostConsent(token, params).subscribe(() => {
                this.redirectLogin();

            },(error) => {
                console.log(error);
            });
        },
        redirectLogin: function() {
            var targetPage = this.page;
            var page = '';
            var code = '';
            var cache = new CacheHelper('session');

            if(targetPage){
                targetPage = targetPage.split('/');
                    if(targetPage.length > 1){
                        page = targetPage[0];
                        code = targetPage[1];
                    }else{
                        page = targetPage[0];
                    }
            }

            switch (page) {
                case "register":
                    window.location.replace('/');
                    break;
                case "home":
                    window.location.replace('/');
                    break;
                case "point":
                    window.location.replace('/point');
                    break;
                case "reward":
                    if(code){
                        cache.setCache('isFromBDM', true);
                        window.location.replace('/reward/'+code);
                    }else{
                        cache.setCache('isFromBDMList', true);
                        window.location.replace('/rewards');
                    }
                    break;

                case "qr":
                    if(code){
                        cache.setCache('BDMCode', code);

                        window.location.replace('/point');
                    }else{
                        window.location.replace('/point');
                    }
                    break;
                case "productpoint":
                    cache.setCache('isFromBDMPointLogin', true);
                    window.location.replace('/point/guide');
                    break;
                default:
                    if (Util.isEmptyStr(page)) {
                        window.location.replace('/');
                    } else {
                        window.location.replace('/'+page);
                    }
                    break;
            }
        },
    },
}
